import { render, staticRenderFns } from "./LanguageTranslations.vue?vue&type=template&id=1b03407e&"
import script from "./LanguageTranslations.vue?vue&type=script&lang=js&"
export * from "./LanguageTranslations.vue?vue&type=script&lang=js&"
import style0 from "./LanguageTranslations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports